import { linkTo } from '@99designs/routing';
import { CollaborationMethod } from '../../types';
import type { ZendeskLanguage } from '@99designs/routing';

export type CollaborationContent = {
    title: string;
    description: string;
    inclusions: string[];
    link?: {
        href: string;
    };
};

export const collaborationMethods = (
    method: CollaborationMethod,
    lang?: ZendeskLanguage
): CollaborationContent => {
    const collaborationMethods: Record<CollaborationMethod, CollaborationContent> = {
        [CollaborationMethod.Contest]: {
            title: __('Contest'),
            description: __(
                'Open your design brief to our entire community. Designers submit their ideas and you pick your favorite design.'
            ),
            inclusions: [
                __('Creative concepts from multiple designers'),
                __('Choose a winning design and receive copyright to the files'),
            ],
            link: {
                href: linkTo.howItWorks(),
            },
        },
        [CollaborationMethod.ContestBundle]: {
            title: __('Contest Bundle'),
            description: __(
                'Open your design brief to our entire community. Designers submit their ideas and you pick your favorite design.'
            ),
            inclusions: [
                __('Creative concepts from multiple designers'),
                __('Choose a winning design and receive copyright to the files'),
                __('Work with the winning designer to finalize deliverables in your bundle'),
            ],
            link: {
                href: linkTo.howItWorks(),
            },
        },
        [CollaborationMethod.OneToOneProject]: {
            title: __('1-to-1 project'),
            description: __(
                "Tell us about your design needs and we'll match you with designers that are best suited to the job"
            ),
            inclusions: [
                __('Designers express interest in your project'),
                __('View portfolios and choose a designer to work with'),
                __('Collaborate on your design'),
            ],
            link: {
                href: linkTo.supportUrl('8934876076692', 'articles', lang || 'en'),
            },
        },
        [CollaborationMethod.Studio]: {
            title: __('Studio'),
            description: __(
                "You'll work with an experienced Brand Strategist from Circlemakers Studio who can lead your brief and shape your brand story with the top talent."
            ),
            inclusions: [
                __("You'll be invited to a 30 minute kick-off call to discuss the next steps."),
                __(
                    'Next, your Brand Strategist will develop a moodboard and schedule a discovery session to set the creative direction.'
                ),
                __(
                    "We'll present creative concepts, refine these to completion, leading the project from end-to-end."
                ),
            ],
            link: {
                href: linkTo.studio(),
            },
        },
        [CollaborationMethod.Care]: {
            title: __('In house design'),
            description: __('In house VistaPrint design'),
            inclusions: [
                __('Professional designers on-hand to deliver custom design, fast.'),
                __(
                    'Your job will be assigned to a designer who will create your design based on the details you provide.'
                ),
                __(
                    'Provide feedback over email or schedule a DesignLive session to review in real-time.'
                ),
                __('Get your print-ready design delivered straight to your VistaPrint account.'),
            ],
        },
    };
    return collaborationMethods[method];
};
